import { render, staticRenderFns } from "./VerificationResult.vue?vue&type=template&id=6b7cc4d3&scoped=true&"
import script from "./VerificationResult.vue?vue&type=script&lang=ts&"
export * from "./VerificationResult.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationResult.vue?vue&type=style&index=0&id=6b7cc4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7cc4d3",
  null
  
)

export default component.exports